import {authAxios} from "../api/axiosClient";
import {approveRequestLeaveSPURL, listDeNghiChamCongQuanLyURL, listDeNghiChamCongURL, listDeNghiPhepDBURL, listLoaiDeNghiURL, regimeCancelURL, remainingLeaveDaysURL} from "../constants";

export const ListLoaiDeNghiApi = (params={})=>{
        const url = listLoaiDeNghiURL;
        return authAxios().get(url,{params});
}

export const listDeNghiChamCongApi = (params={})=>{
        const url = listDeNghiChamCongURL;
        return authAxios().get(url,{params});
}

export const listDeNghiChamCongQuanLyApi = (params={})=>{
        const url = listDeNghiChamCongQuanLyURL;
        return authAxios().get(url,{params});
}

export const createDeNghiChamCongApi = (params={})=>{
        const url = listDeNghiChamCongURL;
        return authAxios().post(url,params);
}

export const ChangeStatusDeNghiChamCongApi = (params={}) =>{
        const url = listDeNghiChamCongQuanLyURL;
        return authAxios().put(url,params);
}

export const RegimeCancelApi = (params={}) =>{
        const url = regimeCancelURL;
        return authAxios().post(url,params);
}

export const listDeNghiPhepDBApi = (params={})=>{
        const url = listDeNghiPhepDBURL;
        return authAxios().get(url,{params});
}

export const ApproveRequestLeaveSPApi = (params={}) =>{
        const url = approveRequestLeaveSPURL;
        return authAxios().put(url,params);
}

export const remainingLeaveDaysAPI = (params={})=>{
        const url = remainingLeaveDaysURL;
        return authAxios().get(url,{params});
}

// export const TaoLichLamViecApi = (params={})=>{
//         const url = listLamViecURL;
//         return authAxios().post(url,params);
// }
//
// export const DeleteItemLichLamViecApi = (params={})=>{
//         const url = listLamViecURL;
//         return authAxios().delete(url,{data:params});
// }
//
// export const EditItemLichLamViecApi = (params={})=>{
//         const url = listLamViecURL;
//         console.log(params);
//         return authAxios().put(url,params);
// }
